import { render, staticRenderFns } from "./FrontpageUk.vue?vue&type=template&id=a0ef4aac&"
import script from "./FrontpageUk.vue?vue&type=script&lang=js&"
export * from "./FrontpageUk.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageUk.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports